export const faqs = [
    {
        question: "How can I place an inquiry?",
        answer:
            "You can place an inquiry by filling out the contact form above with your requirements, and our team will reach out shortly.",
    },
    {
        question: "How quickly will I receive a response?",
        answer:
            "We usually respond within 24 business hours. For urgent queries, feel free to call us directly.",
    },
    {
        question: "Can I call you directly?",
        answer:
            "Yes, you can contact us directly at 022-46033434 during business hours.",
    },
    {
        question: "Where are you located?",
        answer:
            "Office No. 217 Skylark Premises Co-operative Society Ltd. Plot No. 63, Sector 11 CBD Belapur Navi Mumbai – 400614.",
    },
    {
        question: "What are your business hours?",
        answer:
            "Monday to Saturday: 10:00 AM - 6:00 PM. Sunday remains closed.",
    },
];